import { render, staticRenderFns } from "./WorkItemsPanel.vue?vue&type=template&id=577321de&scoped=true"
import script from "./WorkItemsPanel.vue?vue&type=script&lang=js"
export * from "./WorkItemsPanel.vue?vue&type=script&lang=js"
import style0 from "./WorkItemsPanel.vue?vue&type=style&index=0&id=577321de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577321de",
  null
  
)

export default component.exports